import React from 'react';
// @ts-ignore
import styles from './LinkButton.module.scss';
import useTranslation from '../../../../../Hooks/useTranslation';
import { joinClasses } from '../../../../../Utils/className.util';
import FirstUpper from '../../FirstUpper';
import { remove } from '../../../../../Services/ApiClient';

interface Props {
	onClick?: () => void;
	text: string;
	theme: 'purple' | 'red';
	firstUpper?: boolean;
	href?: string;
	className?: string;
}

const LinkButton: React.FC<Props> = ({
	onClick,
	theme,
	text,
	firstUpper = false,
	href,
	className,
}) => {
	const { t } = useTranslation();

	const handleClick = () => {
		onClick?.();
	};

	let title: any = t(text);

	if (firstUpper) {
		title = <FirstUpper>{title}</FirstUpper>;
	}

	if (href) {
		return (
			<a
				className={joinClasses([styles.button, styles[theme], className])}
				href={href}
				target='_blank'
			>
				{title}
			</a>
		);
	}

	return (
		<div
			className={joinClasses([styles.button, styles[theme], className])}
			onClick={handleClick}
		>
			{title}
		</div>
	);
};

export default LinkButton;
